export default __webpack_public_path__ + "static/media/gingerbread-pattern-colourful-384px.a5bfa0ae.svg";